import { PolicyLayout, useSettings, ConfigField } from "@/components/PolicyLayout";

export default function ShippingPolicy() {
  const s = useSettings();
  return (
    <PolicyLayout title="Shipping & Delivery Policy" kicker="How your order reaches you">
      <p>{s.brand} ships across India through reputed courier partners. This policy explains our order processing, dispatch timelines, and what to expect for delivery.</p>

      <h2>1. Order processing time</h2>
      <p>Orders placed before <b>2:00 PM IST</b> on a business day are typically processed and dispatched the same day or the next business day. Orders placed on Sundays and public holidays are processed on the next working day.</p>

      <h2>2. Estimated delivery time</h2>
      <p>Once dispatched, the typical delivery timelines are:</p>
      <ul>
        <li><b>Metro cities</b> (Delhi, Mumbai, Bengaluru, Hyderabad, Chennai, Kolkata, Pune): 2–4 business days</li>
        <li><b>Tier-2 cities:</b> 3–6 business days</li>
        <li><b>Other locations and remote pincodes:</b> 5–9 business days</li>
      </ul>
      <p>These are indicative timelines provided by our courier partners and may vary during festive seasons, extreme weather, or due to reasons beyond our control. For time-critical festival deliveries, we strongly recommend placing your order at least 7 days in advance.</p>

      <h2>3. Shipping coverage</h2>
      <p>We ship pan-India to all serviceable pincodes covered by our courier partners. If your pincode is not currently serviceable, our system will notify you at checkout — please contact our support and we'll try our best to arrange delivery.</p>

      <h2>4. Shipping charges</h2>
      <ul>
        <li><b>Free shipping</b> on all orders above <b>₹399</b>.</li>
        <li>Orders below ₹399 are charged a flat shipping fee of <b>₹80</b>.</li>
        <li>Cash on Delivery may attract an additional handling charge, if applicable — clearly shown at checkout.</li>
        <li>There are no hidden shipping surcharges; the total shown at checkout is the total you pay.</li>
      </ul>

      <h2>5. Order tracking</h2>
      <p>As soon as your order is dispatched, we will send you the courier partner name and the tracking number via email and SMS. You can also view live order status on your <a href="/account">My Account</a> page.</p>

      <h2>6. What happens if my order is delayed?</h2>
      <p>Occasionally, delays happen due to weather, transport strikes, remote-area movement or courier backlog. If your order has not been delivered within the expected timeline plus 3 additional days:</p>
      <ol>
        <li>Check the tracking link for the latest update.</li>
        <li>Contact us at <ConfigField value={s.email} label="business email"/> or <ConfigField value={s.phone} label="phone number"/>.</li>
        <li>We will personally follow up with the courier partner and update you within one business day.</li>
      </ol>

      <h2>7. Damaged package on arrival</h2>
      <p>If the parcel appears visibly damaged or tampered with at the time of delivery, please <b>refuse the delivery</b> and immediately notify us with photographs. If you accept the parcel, please open and inspect it within 48 hours and follow our <a href="/return-policy">Return & Replacement Policy</a>.</p>

      <h2>8. Incorrect delivery address</h2>
      <p>Please double-check the shipping address before placing the order. If a parcel is returned to us because the address is incorrect or incomplete, we can either resend it (with additional shipping charges) or refund the product cost minus the shipping incurred.</p>

      <h2>9. Contact for shipping questions</h2>
      <p>Email <ConfigField value={s.email} label="business email"/> or call/WhatsApp <ConfigField value={s.phone} label="phone number"/> during our support hours ({s.support_hours}).</p>
    </PolicyLayout>
  );
}
